import { AssetGroupsGenericTypes } from "../../../../../constants/assetGroupsGenericTypes";

export const MessageType = Object.freeze({
	email: 1,
	sms: 2,
	chatMessage: 4,
});

export const messageTypes = [
	{ key: 1, resourceKey: "EmailMessage" },
	{ key: 2, resourceKey: "SMSMessage" },
	{ key: 4, resourceKey: "ChatMessage" },
];

export const objectTypes = (resources) => {
	return [
		{
			name: resources["Car"],
			key: AssetGroupsGenericTypes.Car,
		},
		{
			name: resources["Bike"],
			key: AssetGroupsGenericTypes.Bike,
		},
		{
			name: resources["MotorBike"],
			key: AssetGroupsGenericTypes.Motorbike,
		},
	];
};

export const getInitialMessageTemplateFormData = (defaultObjectType = 1, language = null) => ({
	id: null,
	objectType: defaultObjectType || 1,
	messageType: 1,
	useCase: {
		id: 0,
		description: "",
	},
	language: language || "",
	outletId: null,
	outletDescription: "",
	brand: {
		id: 0,
		description: "",
		objectType: 1,
	},
	body: "",
	modified: {
		on: "",
		byLastName: "",
		byFirstName: "",
		avatar: "",
	},
	created: {
		on: "",
		byLastName: "",
		byFirstName: "",
		avatar: "",
	},
	isWaitsOnPremiseDependent: false,
	isWaitsOnPremise: false,
});

export const MAPPABLE_FIELDS_CONFIG = {
	30: {
		[MessageType.email]: [
			"#RegistrationNumber#",
			"#OutletName#",
			"#ApprovalURL#",
		],
		[MessageType.sms]: [
			"#RegistrationNumber#",
			"#CommercialName#",
			"#ApprovalURL#",
		],
	},

	33: {
		[MessageType.email]: [
			"#OutletName#",
			"#RegistrationNumber#",
			"#ApprovalURL#",
		],
		[MessageType.sms]: [
			"#RegistrationNumber#",
			"#CommercialName#",
			"#ApprovalURL#",
		],
	},

	40: {
		[MessageType.email]: [
			"#ContactTitle#",
			"#ContactLastName#",
			"#Brand#",
			"#ModelDescription#",
			"#RegistrationNumber#",
			"#AppointmentDayOfWeek#",
			"#AppointmentDate#",
			"#AppointmentHour#",
			"#OutletName#",
			"#OutletAddress#",
			"#OutletZipCode#",
			"#OutletCity#",
			"#ApprovalURL#",
		],
	},
	41: {
		[MessageType.email]: [
			"#ContactTitle#",
			"#ContactLastName#",
			"#Brand#",
			"#ModelDescription#",
			"#RegistrationNumber#",
			"#AppointmentDayOfWeek#",
			"#AppointmentDate#",
			"#AppointmentHour#",
			"#OutletName#",
			"#OutletAddress#",
			"#OutletZipCode#",
			"#OutletCity#",
			"#ApprovalURL#",
		],
	},
	42: {
		[MessageType.email]: [
			"#ContactTitle#",
			"#ContactLastName#",
			"#Brand#",
			"#ModelDescription#",
			"#RegistrationNumber#",
			"#AppointmentDayOfWeek#",
			"#AppointmentDate#",
			"#AppointmentHour#",
			"#OutletName#",
			"#OutletAddress#",
			"#OutletZipCode#",
			"#OutletCity#",
			"#ApprovalURL#",
		],
	},

	800: {
		[MessageType.email]: [
			"#ContactTitle#",
			"#ContactLastName#",
			"#RegNr#",
			"#OutletName#",
			"#ApprovalURL#",
		],
		[MessageType.sms]: ["#RegNr#", "#CommercialName#", "#ApprovalURL#"],
	},
	802: {
		[MessageType.email]: [
			"#ContactTitle#",
			"#ContactLastName#",
			"#RegNr#",
			"#OutletName#",
			"#ApprovalURL#",
		],
		[MessageType.sms]: ["#RegNr#", "#CommercialName#", "#ApprovalURL#"],
	},
	803: {
		[MessageType.email]: [
			"#ContactTitle#",
			"#ContactLastName#",
			"#RegNr#",
			"#OutletName#",
			"#ApprovalURL#",
		],
		[MessageType.sms]: ["#RegNr#", "#CommercialName#", "#ApprovalURL#"],
	},
	804: {
		[MessageType.email]: [
			"#ContactTitle#",
			"#ContactLastName#",
			"#RegNr#",
			"#OutletName#",
			"#ApprovalURL#",
		],
		[MessageType.sms]: ["#RegNr#", "#CommercialName#", "#ApprovalURL#"],
	},

	810: {
		[MessageType.email]: ["#RegistrationNumber#", "#OutletName#"],
	},
	811: {
		[MessageType.email]: ["#RegistrationNumber#", "#OutletName#"],
	},

	53: {
		[MessageType.email]: [
			"#ApprovalURL#",
			"#OutletName#",
			"#RegistrationNumber#",
			"#Brand#",
			"#ModelDescription#",
			"#MoboDealerGroupLogo#",
			"#OutletAddress#",
			"#OutletZipCode#",
			"#OutletCity#",
			"#AdvisorName#",
			"#AdvisorEmail#",
			"#AdvisorPhone#",
			"#ContactTitle#",
			"#ContactLastName#",
		],
	},

	820: {
		[MessageType.email]: [
			"#ContactTitle#",
			"#ContactLastName#",
			"#RegNr#",
			"#OutletName#",
			"#ApprovalURL#",
		],
		[MessageType.sms]: ["#RegNr#", "#CommercialName#", "#ApprovalURL#"],
	},
	821: {
		[MessageType.email]: [
			"#ContactTitle#",
			"#ContactLastName#",
			"#RegNr#",
			"#OutletName#",
			"#ApprovalURL#",
		],
		[MessageType.sms]: ["#RegNr#", "#CommercialName#", "#ApprovalURL#"],
	},
};

const SIGNABLE_DOCUMENT_GENERAL_MAPPABLE_FIELDS = [
	"#DealerGroupLogo#",
	"#CurrentDate#",
	"#CurrentTime#",
	"#CustomerSignature#",
	"#OutletUserSignature#",
	"#CompanyName#",
	"#CompanyVATNumber#"
];

const SIGNABLE_DOCUMENT_DOSSIER_MAPPABLE_FIELDS = [
	"#DossierNumber#",
	"#Appointment#",
	"#AppointmentDayOfWeek#",
	"#AppointmentDate#",
	"#AppointmentHour#",
	"#OutletName#",
	"#OutletAddress#",
	"#OutletCity#",
	"#OutletZipCode#",
	"#OutletEmailAddress#",
	"#OutletPhoneNumber#",
	"#PickupDateTime#",

	// dossier contact related data
	"#OwnerContactTitle#",
	"#OwnerContactFirstName#",
	"#OwnerContactLastName#",
	"#OwnerContactEmailAddress#",
	"#OwnerContactPhoneNumber#",
	"#OwnerContactAddress#",
	"#OwnerContactZipCode#",
	"#OwnerContactCity#",
	"#OwnerContactCountry#",
	"#OwnerDrivingLicenseNumber#",
	"#OwnerDrivingLicenseIssuedOn#",
	"#OwnerDrivingLicenseExpiresOn#",

	"#CompanyContactTitle#",
	"#CompanyContactFirstName#",
	"#CompanyContactLastName#",
	"#CompanyContactEmailAddress#",
	"#CompanyContactPhoneNumber#",
	"#CompanyContactAddress#",
	"#CompanyContactZipCode#",
	"#CompanyContactCity#",
	"#CompanyContactCountry#",
	"#CompanyDrivingLicenseNumber#",
	"#CompanyDrivingLicenseIssuedOn#",
	"#CompanyDrivingLicenseExpiresOn#",

	"#DriverContactTitle#",
	"#DriverContactFirstName#",
	"#DriverContactLastName#",
	"#DriverContactEmailAddress#",
	"#DriverContactPhoneNumber#",
	"#DriverContactAddress#",
	"#DriverContactZipCode#",
	"#DriverContactCity#",
	"#DriverContactCountry#",
	"#DriverDrivingLicenseNumber#",
	"#DriverDrivingLicenseIssuedOn#",
	"#DriverDrivingLicenseExpiresOn#",

	// object related data
	"#ObjectRegistrationNumber#",
	"#ObjectBrand#",
	"#ObjectModelDescription#",
	"#ObjectIdentifier#",
]

const SIGNABLE_DOCUMENT_CONTACTS_MAPPABLE_FIELDS = [
	"#DrivingLicenseNumber#",
	"#DrivingLicenseExpiryDate#",
	"#DrivingLicenseIssueDate#",
	"#DateOfBirth#",
	"#CityOfBirth#",
]

const SIGNABLE_DOCUMENTS_DRIVE_MAPPABLE_FIELDS = [
	"#DriveBookingContractNumber#",
	"#AssetRegistrationNumber#",
	"#AssetBrand#",
	"#AssetModelDescription#",
	"#AssetIdentifier#",
	"#AssetStartMileage#",
	"#AssetStartFuelLevel#",
	"#AssetEndMileage#",
	"#AssetEndFuelLevel#",
	"#AssetInsuranceDetails#",
	"#ScheduledFrom#",
	"#ScheduledTill#",
	"#ScheduledFromDayOfWeek#",
	"#ScheduledTillDayOfWeek#",
	"#PricePerHour#",
	"#PricePerDay#",
	"#PricePerWeek#",
	"#PricePerMonth#",
	"#AssetIncludedMileage#",
	"#AssetMileageSurplus#",
	"#DriveBookingCheckedOutOn#",
	"#DriveBookingCheckedInOn#",
	"#DriveBookingStartComment#",
	"#DriveBookingEndComment#",
	"#CheckOutCustomerSignature#",
	"#CheckInCustomerSignature#",
	"#CheckOutOutletSignature#",
	"#CheckInOutletSignature#",
	"#DriveBookingDamageReportImage#",
	"#DriveBookingDamageReportList#",
	"#DriveBookingBillings#",
	"#DriveBookingDriverContactTitle#",
	"#DriveBookingDriverFirstName#",
	"#DriveBookingDriverLastName#",
	"#DriveBookingDriverEmailAddress#",
	"#DriveBookingDriverPhoneNumber#",
	"#DriveBookingDriverAddress#",
	"#DriveBookingDriverZipCode#",
	"#DriveBookingDriverCity#",
	"#DriveBookingDriverCountry#",
	"#DriveBookingBillingContactTitle#",
	"#DriveBookingBillingContactFirstName#",
	"#DriveBookingBillingContactLastName#",
	"#DriveBookingBillingContactEmailAddress#",
	"#DriveBookingBillingContactPhoneNumber#",
	"#DriveBookingBillingContactAddress#",
	"#DriveBookingBillingContactZipCode#",
	"#DriveBookingBillingContactCity#",
	"#DriveBookingBillingContactCountry#",
]

export const SIGNABLE_DOCUMENTS_MAPPABLE_FIELDS_CONFIG = {
	"DOSSIER": [...SIGNABLE_DOCUMENT_GENERAL_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_DOSSIER_MAPPABLE_FIELDS],
	"DOSSIER-CHECKIN": [...SIGNABLE_DOCUMENT_GENERAL_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_DOSSIER_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_CONTACTS_MAPPABLE_FIELDS],
	"DOSSIER-CHECKOUT": [...SIGNABLE_DOCUMENT_GENERAL_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_DOSSIER_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_CONTACTS_MAPPABLE_FIELDS],
	"DRIVE": [...SIGNABLE_DOCUMENT_GENERAL_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_DOSSIER_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_CONTACTS_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENTS_DRIVE_MAPPABLE_FIELDS],
	"DRIVE-CHECKIN": [...SIGNABLE_DOCUMENT_GENERAL_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_DOSSIER_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_CONTACTS_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENTS_DRIVE_MAPPABLE_FIELDS],
	"DRIVE-CHECKOUT": [...SIGNABLE_DOCUMENT_GENERAL_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_DOSSIER_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENT_CONTACTS_MAPPABLE_FIELDS, ...SIGNABLE_DOCUMENTS_DRIVE_MAPPABLE_FIELDS],
}

export const MAPPABLE_FIELDS_RESOURCE_KEYS = {
	"#DealerGroupLogo#": "MappableField.DealerGroupLogo",
	"#CurrentDate#": "MappableField.CurrentDate",
	"#CurrentTime#": "MappableField.CurrentTime",
	"#CustomerSignature#": "MappableField.CustomerSignature",
	"#OutletUserSignature#": "MappableField.OutletUserSignature",
	"#DossierNumber#": "MappableField.DossierNumber",
	"#Appointment#": "MappableField.Appointment",
	"#AppointmentDayOfWeek#": "MappableField.AppointmentDayOfWeek",
	"#AppointmentDate#": "MappableField.AppointmentDate",
	"#AppointmentHour#": "MappableField.AppointmentHour",
	"#OutletName#": "MappableField.OutletName",
	"#OutletAddress#": "MappableField.OutletAddress",
	"#OutletCity#": "MappableField.OutletCity",
	"#OutletZipCode#": "MappableField.OutletZipCode",
	"#OutletEmailAddress#": "MappableField.OutletEmailAddress",
	"#OutletPhoneNumber#": "MappableField.OutletPhoneNumber",
	"#OwnerContactTitle#": "MappableField.OwnerContactTitle",
	"#OwnerContactFirstName#": "MappableField.OwnerContactFirstName",
	"#OwnerContactLastName#": "MappableField.OwnerContactLastName",
	"#OwnerContactEmailAddress#": "MappableField.OwnerContactEmailAddress",
	"#OwnerContactPhoneNumber#": "MappableField.OwnerContactPhoneNumber",
	"#OwnerContactAddress#": "MappableField.OwnerContactAddress",
	"#OwnerContactZipCode#": "MappableField.OwnerContactZipCode",
	"#OwnerContactCity#": "MappableField.OwnerContactCity",
	"#OwnerContactCountry#": "MappableField.OwnerContactCountry",
	"#OwnerDrivingLicenseNumber#": "MappableField.OwnerDrivingLicenseNumber",
	"#OwnerDrivingLicenseIssuedOn#": "MappableField.OwnerDrivingLicenseIssuedOn",
	"#OwnerDrivingLicenseExpiresOn#": "MappableField.OwnerDrivingLicenseExpiresOn",
	"#CompanyContactTitle#": "MappableField.CompanyContactTitle",
	"#CompanyContactFirstName#": "MappableField.CompanyContactFirstName",
	"#CompanyContactLastName#": "MappableField.CompanyContactLastName",
	"#CompanyContactEmailAddress#": "MappableField.CompanyContactEmailAddress",
	"#CompanyContactPhoneNumber#": "MappableField.CompanyContactPhoneNumber",
	"#CompanyContactAddress#": "MappableField.CompanyContactAddress",
	"#CompanyContactZipCode#": "MappableField.CompanyContactZipCode",
	"#CompanyContactCity#": "MappableField.CompanyContactCity",
	"#CompanyContactCountry#": "MappableField.CompanyContactCountry",
	"#CompanyDrivingLicenseNumber#": "MappableField.CompanyDrivingLicenseNumber",
	"#CompanyDrivingLicenseIssuedOn#": "MappableField.CompanyDrivingLicenseIssuedOn",
	"#CompanyDrivingLicenseExpiresOn#": "MappableField.CompanyDrivingLicenseExpiresOn",
	"#DriverContactTitle#": "MappableField.DriverContactTitle",
	"#DriverContactFirstName#": "MappableField.DriverContactFirstName",
	"#DriverContactLastName#": "MappableField.DriverContactLastName",
	"#DriverContactEmailAddress#": "MappableField.DriverContactEmailAddress",
	"#DriverContactPhoneNumber#": "MappableField.DriverContactPhoneNumber",
	"#DriverContactAddress#": "MappableField.DriverContactAddress",
	"#DriverContactZipCode#": "MappableField.DriverContactZipCode",
	"#DriverContactCity#": "MappableField.DriverContactCity",
	"#DriverContactCountry#": "MappableField.DriverContactCountry",
	"#DriverDrivingLicenseNumber#": "MappableField.DriverDrivingLicenseNumber",
	"#DriverDrivingLicenseIssuedOn#": "MappableField.DriverDrivingLicenseIssuedOn",
	"#DriverDrivingLicenseExpiresOn#": "MappableField.DriverDrivingLicenseExpiresOn",
	"#ObjectRegistrationNumber#": "MappableField.ObjectRegistrationNumber",
	"#ObjectBrand#": "MappableField.ObjectBrand",
	"#ObjectModelDescription#": "MappableField.ObjectModelDescription",
	"#ObjectIdentifier#": "MappableField.ObjectIdentifier",
	"#DriveBookingContractNumber#": "MappableField.DriveBookingContractNumber",
	"#AssetRegistrationNumber#": "MappableField.AssetRegistrationNumber",
	"#AssetBrand#": "MappableField.AssetBrand",
	"#AssetModelDescription#": "MappableField.AssetModelDescription",
	"#AssetIdentifier#": "MappableField.AssetIdentifier",
	"#AssetStartMileage#": "MappableField.AssetStartMileage",
	"#AssetStartFuelLevel#": "MappableField.AssetStartFuelLevel",
	"#AssetEndMileage#": "MappableField.AssetEndMileage",
	"#AssetEndFuelLevel#": "MappableField.AssetEndFuelLevel",
	"#AssetInsuranceDetails#": "MappableField.AssetInsuranceDetails",
	"#ScheduledFrom#": "MappableField.ScheduledFrom",
	"#ScheduledTill#": "MappableField.ScheduledTill",
	"#ScheduledFromDayOfWeek#": "MappableField.ScheduledFromDayOfWeek",
	"#ScheduledTillDayOfWeek#": "MappableField.ScheduledTillDayOfWeek",
	"#PricePerHour#": "MappableField.PricePerHour",
	"#PricePerDay#": "MappableField.PricePerDay",
	"#PricePerWeek#": "MappableField.PricePerWeek",
	"#PricePerMonth#": "MappableField.PricePerMonth",
	"#AssetIncludedMileage#": "MappableField.AssetIncludedMileage",
	"#AssetMileageSurplus#": "MappableField.AssetMileageSurplus",
	"#DriveBookingCheckedOutOn#": "MappableField.DriveBookingCheckedOutOn",
	"#DriveBookingCheckedInOn#": "MappableField.DriveBookingCheckedInOn",
	"#DriveBookingStartComment#": "MappableField.DriveBookingStartComment",
	"#DriveBookingEndComment#": "MappableField.DriveBookingEndComment",
	"#CheckOutCustomerSignature#": "MappableField.CheckOutCustomerSignature",
	"#CheckInCustomerSignature#": "MappableField.CheckInCustomerSignature",
	"#CheckOutOutletSignature#": "MappableField.CheckOutOutletSignature",
	"#CheckInOutletSignature#": "MappableField.CheckInOutletSignature",
	"#DriveBookingDamageReportImage#": "MappableField.DriveBookingDamageReportImage",
	"#DriveBookingDamageReportList#": "MappableField.DriveBookingDamageReportList",
	"#DriveBookingBillings#": "MappableField.DriveBookingBillings",
	"#DriveBookingDriverContactTitle#": "MappableField.DriveBookingDriverContactTitle",
	"#DriveBookingDriverFirstName#": "MappableField.DriveBookingDriverFirstName",
	"#DriveBookingDriverLastName#": "MappableField.DriveBookingDriverLastName",
	"#DriveBookingDriverEmailAddress#": "MappableField.DriveBookingDriverEmailAddress",
	"#DriveBookingDriverPhoneNumber#": "MappableField.DriveBookingDriverPhoneNumber",
	"#DriveBookingDriverAddress#": "MappableField.DriveBookingDriverAddress",
	"#DriveBookingDriverZipCode#": "MappableField.DriveBookingDriverZipCode",
	"#DriveBookingDriverCity#": "MappableField.DriveBookingDriverCity",
	"#DriveBookingDriverCountry#": "MappableField.DriveBookingDriverCountry",
	"#DriveBookingBillingContactTitle#": "MappableField.DriveBookingBillingContactTitle",
	"#DriveBookingBillingContactFirstName#": "MappableField.DriveBookingBillingContactFirstName",
	"#DriveBookingBillingContactLastName#": "MappableField.DriveBookingBillingContactLastName",
	"#DriveBookingBillingContactEmailAddress#": "MappableField.DriveBookingBillingContactEmailAddress",
	"#DriveBookingBillingContactPhoneNumber#": "MappableField.DriveBookingBillingContactPhoneNumber",
	"#DriveBookingBillingContactAddress#": "MappableField.DriveBookingBillingContactAddress",
	"#DriveBookingBillingContactZipCode#": "MappableField.DriveBookingBillingContactZipCode",
	"#DriveBookingBillingContactCity#": "MappableField.DriveBookingBillingContactCity",
	"#DriveBookingBillingContactCountry#": "MappableField.DriveBookingBillingContactCountry",
	"#PickupDateTime#": "MappableField.PickupDateTime",
	"#DrivingLicenseNumber#": "MappableField.DrivingLicenseNumber",
	"#DrivingLicenseExpiryDate#": "MappableField.DrivingLicenseExpiryDate",
	"#DrivingLicenseIssueDate#": "MappableField.DrivingLicenseIssueDate",
	"#DateOfBirth#": "MappableField.Birthday",
	"#CityOfBirth#": "MappableField.CityOfBirth",
}